import { lazyInject } from '@app/containers/base/decorators';
import { IQohInventoryItemVenue } from '@app/shared/types/entities/transfer/transfer.type';
import { NumberFormatService } from '../../number-format';

import { TRANSFER_FORM_FIELD_PATHS } from '../../transfer/transfer-form-field-paths';
import {
  IReplenishDestination,
  ReplenishDestItemParams,
} from '../replenish.types';
import { ReplenishTransferQOHStrategy } from './replenish-transfer-qoh-strategy';
import { replenishInventoryItem } from './utils/replenish-calc.utils';
import { zeroQohCalculator } from './calculators';

class ReplenishTransferZeroQOHStrategy<
  T extends IReplenishDestination = IReplenishDestination,
> extends ReplenishTransferQOHStrategy<T> {
  @lazyInject(NumberFormatService)
  public numberFormatService: NumberFormatService;

  /**
   * replenish destination single item method, you can override this to use different calc method here
   *
   * @param params calc params
   * @returns calc result
   */
  public replenishDestinationItem(
    params: ReplenishDestItemParams,
  ): IQohInventoryItemVenue {
    return replenishInventoryItem({
      fieldPath: TRANSFER_FORM_FIELD_PATHS,
      item: params.item,
      threshold: params.threshold,
      percent: params.percent,
      calculator: zeroQohCalculator,
      additionalData: params.additionalData,
    });
  }
}

export { ReplenishTransferZeroQOHStrategy };
